import styled from "styled-components"
import { Row, Col, Container } from "react-bootstrap";
import { Tabs } from 'antd';
import type { TabsProps } from 'antd';

import { BPSTabsStyled } from "../styled/BPSTabs";



const onChange = (key: string) => {
    console.log(key);
};

const items: TabsProps['items'] = [
    {
        key: '1',
        label: 'Physical Reward Cards',
        children: <div>
            <Container fluid>
                <h3 className="fs-48 text-center pt-4">
                    Physical Visa reward cards:
                    <br />
                    tangible motivation</h3>
                <Row className="justify-content-evenly text-center">
                    <Col md={3} className='py-md-5'>
                        {/* <img src={GraphIcon} width={60} /> */}
                        <h4 className='fs-20 pt-4'>Reward freedom for every occasion</h4>
                        <p>
                            Suitable for both online and in-store use, our Visa products both physical and virtual reward cards effortlessly motivate dealer incentives, customers payments.
                        </p>
                    </Col>
                    <Col md={3} className='py-md-5'>
                        {/* <img src={GraphIcon} width={60} /> */}
                        <h4 className='fs-20 pt-4'>Broad usability</h4>
                        <p>
                            Participants can effortlessly make purchases in-person or online, offering them a world of choices.
                        </p>
                    </Col>
                    <Col md={3} className='py-md-5'>
                        {/* <img src={GraphIcon} width={60} /> */}
                        <h4 className='fs-20 pt-4'>Safe & streamlined distribution</h4>
                        <p>
                            With physical Visa Reward Cards you're not just offering a reward but also the tangible sensation of receiving a gift, making the recognition even more memorable. The freedom to choose is very powerful when it comes to Rewards.
                        </p>
                    </Col>
                </Row>
            </Container>
        </div>,
    },
    {
        key: '2',
        label: 'Virtual Reward Cards',
        children: <div>
            <Container fluid>
                <h3 className="fs-48 text-center pt-4">
                    Virtual Visa reward cards:
                    <br />
                    digital delight</h3>
                <Row className="justify-content-evenly text-center">
                    <Col md={4} className='py-md-5'>
                        {/* <img src={GraphIcon} width={60} /> */}
                        <h4 className='fs-20 pt-4'>Instant rewards, massive engagement</h4>
                        <p>
                            Deliver instant gratification right to their inboxes. Our virtual Visa cards are not only compatible with digital wallets but are also accepted across thousands of online retailers.
                        </p>
                    </Col>
                    <Col md={4} className='py-md-5'>
                        {/* <img src={GraphIcon} width={60} /> */}
                        <h4 className='fs-20 pt-4'>Easy adoption, maximum convenience</h4>
                        <p>
                            In a world driven by digital convenience, offering virtual Visa rewards ensures quick adoption and appreciation. Recipients can pick and choose their rewards, mirroring today's preference for personalization.
                        </p>
                    </Col>
                </Row>
            </Container>
        </div>,
    },
    
];

const PrepaidCardsTabs = () => {
    return (
        <BPSTabsStyled>
            <Tabs defaultActiveKey="1" items={items} onChange={onChange} centered />
        </BPSTabsStyled>
    );
}


export { PrepaidCardsTabs }
